import React from 'react';
import { Row, Col } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Image as ImageIcon, Newspaper, ArrowRight } from 'lucide-react';

import NewFaceView from './NewFaceView';
import CaroselMultiView from './CaroselMultiView';
import VidyaJyotiBanner from '../VidyaJyotiBanner';
import TheologicalInsights from './TheologicalInsights';
import CelebrationHub from './celebrations/CelebrationHub';
import UpcomingMain from './upcomingEvents/UpcomingMain';
import PhotoGalleryHome from '../gallery/PhotoGalleryHome';
import TimelineVJ from '../../pages/TimeLineVJ/TimelineVJ';
import FieldWorkContent from '../fieldwork/FieldWorkContent';
import Services from '../publications/Services';
import ContactContent from '../contact/ContactContent';

export default function HomePage() {
  return (
    <div className="home-sec bg-slate-50">
      <Helmet>
        <title>Vidyajyoti College of Theology - Delhi || Institute of Religious Studies</title>
        <meta name="description" content="Vidyajyoti College of Theology - Delhi || Jesuit Institute of Religious Studies with over 150 years of contextual theologizing and transformative formation." />
        <meta name="keywords" content="Vidyajyoti, College of Theology, Jesuit, Delhi, Theological Studies, BTh, MTh, Formation" />
        <link rel="canonical" href="/" />
      </Helmet>

      <div className="container-fluid px-lg-4 px-3 py-3">
        {/* Section 1: Hero Carousel & Theological Insights */}
        <Row className="g-4 align-items-stretch mb-4">
          <Col lg={9} md={12} className="d-flex flex-column justify-content-between">
            <CaroselMultiView />
            <NewFaceView />
          </Col>
          <Col lg={3} md={12} className="d-flex flex-column">
            <TheologicalInsights />
          </Col>
        </Row>

        {/* Section 2: Celebrations & Greetings Hub (Birthdays, Ordinations, Feast Days & Milestones) */}
        {/*} <CelebrationHub />*/}

        {/* Section 3: Highlights - Upcoming Events, About VJ, Principal Desk */}
        <UpcomingMain />

        {/* Section 3: College Motto Banner */}
        <VidyaJyotiBanner />

        {/* Section 4: Gallery & Top Stories */}
        <section className="vj-media-section py-4">
          <Row className="g-4">
            {/* Gallery Section */}
            <Col xl={8} lg={7} md={12}>
              <div className="vj-modern-card p-4 h-100 d-flex flex-column">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                  <div className="d-flex align-items-center gap-2">
                    <div className="vj-icon-badge">
                      <ImageIcon size={20} />
                    </div>
                    <h3 className="vj-card-title">Campus Gallery</h3>
                  </div>
                  <Link to="/gallery/photo" className="vj-btn-outline btn-sm">
                    View All Photos <ArrowRight size={15} />
                  </Link>
                </div>
                <div className="flex-grow-1">
                  <PhotoGalleryHome task="Home" />
                </div>
              </div>
            </Col>

            {/* VJ Top Stories */}
            <Col xl={4} lg={5} md={12}>
              <div className="vj-modern-card p-4 h-100 d-flex flex-column">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                  <div className="d-flex align-items-center gap-2">
                    <div className="vj-icon-badge burgundy">
                      <Newspaper size={20} />
                    </div>
                    <h3 className="vj-card-title">Top Stories</h3>
                  </div>
                  <Link to="/about/vjtopstories" className="vj-btn-outline btn-sm">
                    All Stories <ArrowRight size={15} />
                  </Link>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <TimelineVJ />
                </div>
                <div className="pt-3 text-center border-top mt-3">
                  <Link to="/about/vjtopstories" className="vj-btn-primary w-100 justify-content-center">
                    Explore All Top Stories <ArrowRight size={16} />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </section>

        {/* Section 5: Field Work */}
        <FieldWorkContent />

        {/* Section 6: Publications & Services */}
        <Services />

        {/* Section 7: Contact Form & Map */}
        <ContactContent />
      </div>
    </div>
  );
}
